var $ = global.jQuery = global.$;
var _debounce = require('lodash/function/debounce');
var _delay = require('lodash/function/debounce');
var velocity = require('velocity-animate');
var _Base = require('./_Base');

/**
 * Mobile navigation widget
 * @class
 * @extends _Base
 */
var SubNavItem = _Base.extend(
  /** @lends SubNavItem.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;
    this._delayedShow = _delay(this.show, 250);
    this._delayedHide = _delay(this.hide, 100);
    this.$subnav = this.$el.find('[data-subnav-container]').eq(0);
    this.$el.on('mouseover', this.delayedShow.bind(this));
    this.$el.on('mouseout', this.delayedHide.bind(this));
  },
  delayedShow: function() {
    this.hovered = true;
    this._delayedShow();
  },
  delayedHide: function() {
    this.hovered = false;
    this._delayedHide();
  },
  show: function() {
    if (this.$el.hasClass('is-open') || !this.hovered) return false;
    this.$el.addClass('is-open');
    this.$subnav.velocity('fadeIn', { duration: 300 });
  },
  hide: function() {
    if (!this.$el.hasClass('is-open') || this.hovered) return false;
    this.$el.removeClass('is-open');
    this.$subnav.hide();
  }
});

module.exports = SubNavItem;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/SubNavItem.js
// module id = 271
// module chunks = 0